export function focus(elementName){
setTimeout(() => {
    console.log("Focusing on ", elementName);
        const next = document.querySelector(`[name="${elementName}"]`);
        next?.focus();
      }, 100);
}

// Helper function to calculate age from DOB
export function calculateAge(dob) {
  if (!dob) return '';
  
  let birthDate;
  // Handle dd/mm/yyyy format which is standard in this app
  if (typeof dob === 'string' && dob.includes('/') && dob.split('/').length === 3) {
    const parts = dob.split('/');
    // Assuming dd/mm/yyyy
    const day = parseInt(parts[0], 10);
    const month = parseInt(parts[1], 10) - 1; // Months are 0-indexed in JS Date
    const year = parseInt(parts[2], 10);
    birthDate = new Date(year, month, day);
  } else {
    // Fallback for other formats
    birthDate = new Date(dob);
  }

  // Check if date is valid
  if (isNaN(birthDate.getTime())) return '';

  const today = new Date();
  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDiff = today.getMonth() - birthDate.getMonth();
  
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }

  return age;
}